
import { Component, Vue, Prop} from 'vue-property-decorator';

import PageBase from "../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase
    }
})

export default class IncomeInformation extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = false;
    tableKey = 0;
    
    nameOfEmployer = "";
    govSource = "";
    otherDesc = "";

    incomeInformationItem = [
        {income: false, incomeName:"employee",       monthlyAmount: 0, yearlyAmount: 0},
        {income: false, incomeName:"EI",             monthlyAmount: 0, yearlyAmount: 0},
        {income: false, incomeName:"WCB",            monthlyAmount: 0, yearlyAmount: 0},
        {income: false, incomeName:"investment",     monthlyAmount: 0, yearlyAmount: 0},
        {income: false, incomeName:"pension",        monthlyAmount: 0, yearlyAmount: 0},    
        {income: false, incomeName:"govAssist",      monthlyAmount: 0, yearlyAmount: 0},
        {income: false, incomeName:"selfEmployed",   monthlyAmount: 0, yearlyAmount: 0},
        {income: false, incomeName:"trust",          monthlyAmount: 0, yearlyAmount: 0},  
        {income: false, incomeName:"partnership",    monthlyAmount: 0, yearlyAmount: 0},  
        {income: false, incomeName:"other",          monthlyAmount: 0, yearlyAmount: 0}  
        
    ];

    incomeInformationFields = [
        {key:"income",          label:"",               tdClass:"border-right-0 align-middle",  thClass:"border-right-0",               thStyle:"font-size:12pt; width:3%;"}, 
        {key:"incomeName",      label:"Income",         tdClass:"border-left-0 align-middle",   thClass:"text-primary border-left-0",   thStyle:"font-size:12pt; width:60%;"}, 
        {key:"monthlyAmount",   label:"Monthly amount", tdClass:"border-top-0 align-middle",    thClass:"text-primary",                 thStyle:"font-size:12pt; width:18%;"},
        {key:"yearlyAmount",    label:"Yearly amount",  tdClass:"border-top-0 align-middle",    thClass:"text-primary",                 thStyle:"font-size:12pt; width:19%;"}      
    ]

    mounted(){        
        this.reloadPageInformation();
    } 
    
    public reloadPageInformation() {        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.step.result?.incomeInformationSurvey?.data) {
            const incomeData = this.step.result.incomeInformationSurvey.data
            if (incomeData.incomeAmounts){
                this.incomeInformationItem = this.step.result?.incomeInformationSurvey?.data?.incomeAmounts;
            }
            this.nameOfEmployer = incomeData.nameOfEmployer?incomeData.nameOfEmployer:''; 
            this.govSource = incomeData.govSource?incomeData.govSource:'';
            this.otherDesc = incomeData.otherDesc?incomeData.otherDesc:'';          
            
            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        }      

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, false);
    }

    public inputYearlyValueChanged(data){    
        this.incomeInformationItem[data.index].monthlyAmount = this.incomeInformationItem[data.index].yearlyAmount/12;
        this.tableKey ++;
    }

    public incomeTypeChanged(data){
        if(data.value == false){
            this.incomeInformationItem[data.index].monthlyAmount = 0;
            this.incomeInformationItem[data.index].yearlyAmount = 0;
        }
        this.tableKey ++;
    }

    public inputMonthlyValueChanged(data){
        this.incomeInformationItem[data.index].yearlyAmount = 12 * this.incomeInformationItem[data.index].monthlyAmount;        
        this.tableKey ++;
    }    

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage()
    }

    public getIncomeResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        if(this.getIncomeInfo()){

            const incomeInfo = this.getIncomeInfo().incomeAmounts;
            for(const incomeType of incomeInfo) {
                if(incomeType.income)
                    questionResults.push({name:'incomeInformationSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.incomeName) +' yearly amount:', inputType:''})
            }
        }  
        
        return {data: this.getIncomeInfo(), questions:questionResults, pageName:'Income Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getIncomeInfo(){

        let employer = "";
        let source = "";
        let other = "";

        if(this.incomeInformationItem[0].income){
            employer = this.nameOfEmployer;
        }

        if(this.incomeInformationItem[5].income){
            source = this.govSource;
        }

        if(this.incomeInformationItem[9].income){
            other = this.otherDesc;
        }

        let result = {
            incomeAmounts: this.incomeInformationItem,  
            nameOfEmployer: employer,
            govSource: source,
            otherDesc: other
        }

        return result
    }
    
    beforeDestroy() {        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);        
        this.UpdateStepResultData({step:this.step, data: {incomeInformationSurvey: this.getIncomeResults()}})
    }
}
